import * as React from 'react';
import PageButton from './PageButton';
import IPaginationButtonProps from './types';

const LastPage: React.FC<IPaginationButtonProps> = (props) => {
  return (
    <PageButton {...props} className="control">
      <svg
        className="pagination-icon last-page"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        data-testid="last-page-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1.31081 4.40193L5.41429 8.50541L1.31081 12.6089C0.898349 13.0213 0.898349 13.6876 1.31081 14.1001C1.72327 14.5125 2.38957 14.5125 2.80203 14.1001L7.65639 9.24573C8.06885 8.83326 8.06885 8.16698 7.65639 7.75452L2.80203 2.90015C2.60447 2.70211 2.33617 2.59082 2.05642 2.59082C1.77666 2.59082 1.5084 2.70211 1.31081 2.90015C0.908925 3.31261 0.898349 3.98947 1.31081 4.40193Z" />
        <path d="M14.0015 3.55C14.0015 2.9701 13.5537 2.5 13.0015 2.5C12.4492 2.5 12.0015 2.9701 12.0015 3.55V13.45C12.0015 14.0299 12.4492 14.5 13.0015 14.5C13.5537 14.5 14.0015 14.0299 14.0015 13.45V3.55Z" />
      </svg>
    </PageButton>
  );
};

export default LastPage;
